<template>
  <MainPage>
    <form class='page-login-form'>
      <div class='logo-arvalis'/>
      <div class='wrap'>
        <label for='email'>
          Saisissez votre identifiant (email), vous recevrez un lien de réinitialisation du mot de passe par email (pensez à regarder dans les spams) :
        </label>
        <input v-focus v-model='email' type='text' name='email' id='email' required placeholder='Identifiant de connexion (email)' >
      </div>
      <div class="ct-flex-row ct-jc-space">
        <input type='button' class="primary-action" @click="send" name='Send' value='Envoyer'>
        <input type='button' class="secondary-action" @click="$router.push('/login')" value="Retour" />
      </div>
    </form>
  </MainPage>
</template>

<script>
import MainPage from './MainPage'
import { mapActions } from 'vuex'

export default {
  name: 'recoverPassword',

  components: {
    MainPage
  },

  data () {
    return {
      email: null
    }
  },
  methods: {
    ...mapActions(['askReset']),

    send () {
      this.askReset({
        email: this.email
      })
        .then(() => {
          this.$store.dispatch('success', { message: 'Message envoyé avec succès.' })
          this.$router.push({ name: 'login' })
        })
        .catch(() => {
          alert('Erreur lors de l\'envoi du mail')
        })
    }
  }
}
</script>
